"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cssValuesProp = exports.cssValueProp = exports.cssProp = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _stylesUtils = require("./stylesUtils");
var cssProp = function cssProp(selector, value) {
  if (!value) {
    return undefined;
  }
  return selector(value) || value;
};
exports.cssProp = cssProp;
var cssValueProp = function cssValueProp(selector, value, key) {
  if (!value) {
    return {};
  }
  var themeValue = selector(value);
  return (0, _defineProperty2.default)({}, key, themeValue !== null ? themeValue : value);
};
exports.cssValueProp = cssValueProp;
var cssValuesProp = function cssValuesProp(themeSelector, values, key) {
  if (values === undefined) {
    return {};
  }
  var getValue = function getValue(value) {
    return value !== undefined ? (0, _stylesUtils.px)(themeSelector(value) || value) : undefined;
  };
  if (typeof values === 'number' || typeof values === 'string') {
    return (0, _defineProperty2.default)({}, key, getValue(values));
  }
  if (Array.isArray(values)) {
    if (values.length === 0) {
      return {};
    }
    return (0, _defineProperty2.default)({}, key, values.map(getValue).join(' '));
  }
  if ((0, _typeof2.default)(values) === 'object') {
    var _ref4;
    return _ref4 = {}, (0, _defineProperty2.default)(_ref4, "".concat(key, "Top"), getValue(values.top)), (0, _defineProperty2.default)(_ref4, "".concat(key, "Right"), getValue(values.right)), (0, _defineProperty2.default)(_ref4, "".concat(key, "Bottom"), getValue(values.bottom)), (0, _defineProperty2.default)(_ref4, "".concat(key, "Left"), getValue(values.left)), _ref4;
  }
  return {};
};
exports.cssValuesProp = cssValuesProp;